var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.VALUE == 2)?_c('vs-chip',{attrs:{"color":"#24c1a0"}},[_vm._v("\n    Sevk Tamamlandı\n  ")]):_c('vs-chip',{attrs:{"color":"danger"}},[_vm._v("\n    Henüz Tamamlanmadı\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }